module.exports = __webpack_public_path__ + "static/media/customer-success-siemens-xpick.468122d7.jpg";